import React, { memo } from 'react';
import Image from 'next/image';

import { ITypo } from '@/app/_components/common';
import { Images } from '@/app/assets/images';
import { getImageUrl } from '@/utils';



interface IProps {
	avatar: any;
	images: any;
	studentName: string;
	feedback: string;
	studentInformation: string;
	setItemSelected: (item: any) => void;
}

const SlideCard: React.FC<IProps> = (props) => {
	
	return (
		<>
			<div className="mx-3 overflow-hidden rounded-xl">
				<div
					className="relative aspect-square w-full min-w-[56%] lg:size-[274px]"
					onClick={() => props.setItemSelected(props)}
				>
					<Image
						src={
							getImageUrl(props?.avatar, Images.home.heroBanner)
								.imageUrl
						}
						blurDataURL={
							getImageUrl(props?.avatar, Images.home.heroBanner)
								.imagePlaceholder
						}
						placeholder="blur"
						alt={props?.studentInformation || 'DLA Da Nang'}
						className="object-cover object-center"
						fill
					/>
				</div>

				<div className="relative -top-8" onClick={() => props.setItemSelected(props)}>
					<div className="relative z-[1] h-[100px] w-full lg:min-h-[106px]">
						<Image
							src={Images.home.proudCardFrame}
							alt="DLA Da Nang"
							fill
						/>
					</div>

					<div className="col absolute left-0 top-0 z-[1] gap-[4px] px-3 py-2 text-white lg:py-3">
						<ITypo
							size={14}
							weight="semi"
							as="h3"
							className="lg:text-16 line-clamp-1"
						>
							{props.studentName}
						</ITypo>
						{/* <ITypo size={12} as="p" className="line-clamp-1">
							{props.feedback}
						</ITypo> */}
						<ITypo
							size={12}
							as="p"
							weight="semi"
							className="lg:text-14 line-clamp-1"
						>
							{props.studentInformation}
						</ITypo>
					</div>
				</div>
			</div>
			
		</>
	);
};

export default memo(SlideCard);
